import { render, staticRenderFns } from "./StandappSetPasswordComponent.vue?vue&type=template&id=cef0b090&"
import script from "./StandappSetPasswordComponent.vue?vue&type=script&lang=js&"
export * from "./StandappSetPasswordComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports